/**
 * Seeded users for `VITE_USE_MOCK_DATA=true`. Shapes follow the
 * `@shared/contracts` wire contracts, so mock mode and the real backend are
 * indistinguishable to everything above the API client.
 */
import type { UserResponse } from "@shared/contracts";

export const mockUsers: UserResponse[] = [
  {
    id: 1,
    first_name: "Ada",
    last_name: "Lovelace",
    email: "ada.lovelace@example.com",
    roles: [{ id: 1, name: "admin" }],
    permissions: [],
  },
  {
    id: 2,
    first_name: "Grace",
    last_name: "Hopper",
    email: "grace.hopper@example.com",
    roles: [{ id: 1, name: "admin" }],
    permissions: [],
  },
  {
    id: 3,
    first_name: "Alan",
    last_name: "Turing",
    email: "alan.turing@example.com",
    roles: [{ id: 1, name: "admin" }],
    permissions: [],
  },
];
